import { getDisputeTypes, getUploadUrl } from "../../store/actions/Disputes";
import { Api } from "../config/request";

export default {
  getDisputesList(queryParams) {
    return Api.get(`/disputes${queryParams}`);
  },
  getUploadUrl(payload) {
    return Api.post("/bulk-upload/presigned-url", payload);
  },
  getDisputeTypes() { 
    return Api.get("/dispute/types");
  }
};
